export default "__VITE_ASSET__CSTZGvzn__"